/*@ngInject*/
const ComponentSettingsMediator = function (fieldTemplateComponentRepository) {

    this.getFieldTemplateComponentSettings = function (fieldType, uiFormTemplateId) {
        return fieldTemplateComponentRepository.getFieldTemplateComponentSettings(fieldType, uiFormTemplateId);
    };

    this.getFieldTemplateComponentTypes = function () {
        return fieldTemplateComponentRepository.getFieldTemplateComponentTypes();
    };
};

angular.module('ums.configuration')
    .service('componentSettingsMediator', ComponentSettingsMediator);
